import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import classnames from 'classnames';
import './BusyOverlay.css';

function BusyOverlay({ active = true, label = 'Cargando...' }) {
	const ref = useRef(null);
	const [container, setContainer] = useState(null);

	useLayoutEffect(() => {
		let el = ref.current?.parentElement;
		while (el) {
			if (el.classList?.contains('modal-content')) {
				setContainer(el);
				return;
			}
			el = el.parentElement;
		}
		setContainer(null);
	}, []);

	useLayoutEffect(() => {
		if (!active || !container) return undefined;
		const previousPosition = container.style.position;
		if (!previousPosition) {
			container.style.position = 'relative';
		}
		return () => {
			container.style.position = previousPosition;
		};
	}, [active, container]);

	if (!active) {
		return <span ref={ref} style={{ display: 'none' }} />;
	}

	const overlay = (
		<div
			className={classnames(
				'busy-overlay tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center tw:bg-black/35 tw:backdrop-blur-[1px]',
				container ? 'tw:absolute tw:rounded-[9px]' : 'tw:fixed',
			)}
			aria-busy='true'
			aria-live='polite'
			role='status'
		>
			<div className='tw:flex tw:flex-col tw:items-center tw:gap-3 tw:rounded-[8px] tw:border tw:border-border tw:bg-surface tw:px-5 tw:py-4 tw:shadow-lg'>
				<span aria-hidden='true' className='busy-overlay__spinner' />
				<span className='tw:text-[13px] tw:font-semibold tw:text-ink-1'>{label}</span>
			</div>
		</div>
	);

	return (
		<>
			<span ref={ref} style={{ display: 'none' }} />
			{container ? createPortal(overlay, container) : overlay}
		</>
	);
}

BusyOverlay.propTypes = {
	active: PropTypes.bool,
	label: PropTypes.string,
};

export default BusyOverlay;
